export const environment = {
  production: true,
  apiUrl: 'https://audience-brain-server-419255733644.europe-west1.run.app'
};
